import { Button, Picture, Text } from '../../../../components/index.js'
import { useAiuiContext } from '../../../AiuiProvider/index.js'
import { cn } from '../../../../helpers/index.js'

const LearnMore = (props: any) => {
  const { className, setOpenShippingPolicyModal, metafields } = props
  const { copyWriting } = useAiuiContext()

  return (
    <div
      tabIndex={-1}
      className={cn(
        'from-4.29% to-101.05% laptop:rounded-2xl laptop:py-5 relative items-start gap-[16px] overflow-hidden rounded-xl bg-gradient-to-r from-[rgba(215,245,254,0.24)] to-[rgba(215,245,254,0.80)] p-4 text-[#1F2021] md:py-[16px]',
        'flex flex-col',
        className
      )}
    >
      <Picture source={metafields?.shippingPolicyIcon} className="absolute -bottom-10 -right-10 z-[1] size-[150px]" />
      <div className="relative z-10 flex w-full items-start justify-between">
        <div className="laptop:gap-2 lg-desktop:gap-4 flex flex-col gap-3">
          <Text size={2} className="laptop:text-[16px] lg-desktop:text-[18px] text-[14px]">
            {metafields?.shippingPolicyTitle}
          </Text>
          <Text size={1} as="p" className="laptop:text-[14px] text-[12px] text-[#6D6D6F]">
            {metafields?.loginBeforeCheckoutNote}
          </Text>
        </div>
        <Button
          variant="link"
          className="laptop:inline-flex hidden whitespace-nowrap !p-0"
          onClick={() => {
            setOpenShippingPolicyModal(true)
          }}
        >
          {copyWriting?.learnMore}
        </Button>
      </div>

      <Button
        variant="link"
        className="laptop:hidden inline-flex p-0"
        onClick={() => {
          setOpenShippingPolicyModal(true)
        }}
      >
        {copyWriting?.learnMore}
      </Button>
    </div>
  )
}

export default LearnMore
